import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import CreateDepartment from "@/features/departaments/create-department";
import DepartmentsTable from "@/features/departaments/departments-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/departaments/",
)({
  beforeLoad: ({ context }) => {
    const canReadDepartments = context.ability.can("read", "Department");

    if (!canReadDepartments) {
      console.error("User does not have permission to read departments");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  component: DepartmentsPage,
});

function DepartmentsPage() {
  const { museumId } = Route.useParams();
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Avdelinger</Trans>
        </h1>

        <Can I="create" a="Department">
          <CreateDepartment museumId={museumId} />
        </Can>
      </Flex>

      <DepartmentsTable museumId={museumId} />
    </Box>
  );
}
